import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';

const styles = () => ({
  root: {
    position: 'absolute',
    width: 'auto',
    height: 'auto',
    maxWidth: '100%',
  },
});

const DocumentPreviewFillLogo = ({
  x,
  y,
  width,
  documentPrintWidth,
  documentPrintHeight,
  business,
  order,
  fieldsShift,
  classes,
}) => {
  let src;
  if (order && order.Facility && order.Facility.Image && order.Facility.Image.ID) {
    src = `${order.Facility.Image['File Url']}${order.Facility.Image['File Name']}`;
  } else if (business.Image && business.Image.ID) {
    src = `${business.Image['File Url']}${business.Image['File Name']}`;
  }
  const maxWidth = width || documentPrintWidth - x;
  if (!src) {
    return '';
  }
  return (
    <img
      className={classes.root}
      style={{
        left: `${((x + fieldsShift.x) / documentPrintWidth) * 100}%`,
        top: `${((y + fieldsShift.y) / documentPrintHeight) * 100}%`,
        width: `${(maxWidth / documentPrintWidth) * 100}%`,
      }}
      alt="Company Logo"
      src={src}
    />
  );
};

DocumentPreviewFillLogo.propTypes = {
  x: PropTypes.number.isRequired,
  y: PropTypes.number.isRequired,
  width: PropTypes.number,
  documentPrintWidth: PropTypes.number.isRequired,
  documentPrintHeight: PropTypes.number.isRequired,
  business: PropTypes.shape({
    ID: PropTypes.number,
  }),
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
  }).isRequired,
};

DocumentPreviewFillLogo.defaultProps = {
  width: null,
  business: {},
};

export default withStyles(styles)(DocumentPreviewFillLogo);



// WEBPACK FOOTER //
// ./src/components/common/DocumentPreviewFillForm/DocumentPreviewFillLogo.js